export const EVENT_ORIGINS = {
    local: "http://localhost:8080",
    developer: "https://developer.alterbios.com",
    production: "https://perxona.com",
    developerPerxona: "https://developer.perxona.com",
    wwwPerxona: "https://www.perxona.com"
}